import React from 'react';
import InputNotification from './InputNotification';
//import PropTypes from 'prop-types';

const Input = ({name, label, placeholder, error, type, togglePasswordShow, passwordShow, min, step, ...rest}) => {
    let label_var = label;
    if (label === "http://yourdomain.com") {
        label_var = ""
    }
    return (
        <div className="form-group">
            {/*<label>{label_var}</label>*/}
            <input min={min} name={name} placeholder={placeholder}
                   step={step}
                   type={type} {...rest}/>
            {window.location.href.indexOf("register") || window.location.href.indexOf("login") > -1 || window.location.href.indexOf("/edit-profile/security") > -1 ?

                ''

                : type === 'password' ?
                    <i className='fa fa-eye password-eye-opacity' onClick={togglePasswordShow}></i> :
                    passwordShow && (name.includes("password")) ?
                        <i className='fa fa-eye password-eye ' onClick={togglePasswordShow}></i> :
                        null
            }

            {error && <div className="alert alert-danger" style={{padding: 0, color: "#EF4848"}}>
                <InputNotification type={'danger'} text={error}/>
            </div>}
        </div>

    );
};


//Input.propTypes = {
//    name: PropTypes.number.isRequired,
//    pageSize: PropTypes.number.isRequired,
//    currentPage: PropTypes.number.isRequired,
//    onPageChange: PropTypes.func.isRequired
//};

export default Input;
